import { useState } from 'react';
import './Deposit.css';
import { useUI } from '../../hooks/useUI';
import { addToCardBalance, userStatistics } from '../../utils/api';

const Deposit = (props) => {
    const [isValid, setIsValid] = useState(true);
    const [depositAmount, setDepositAmount] = useState('');

    const { userData, setUserData, closeModal } = useUI();

    async function validateDepositAmount() {
        try {
            let testDepositAmount = Number(depositAmount);
            if (depositAmount > userData.user_usd_balance || depositAmount <= 0 || testDepositAmount != depositAmount) return setIsValid(false);

            await addToCardBalance(window.Telegram.WebApp.initData, testDepositAmount);

            const response = await userStatistics(window.Telegram.WebApp.initData);
            setUserData(response.result);
            closeModal('modalWindow');
        } catch (err) {
            console.log(err);
            setIsValid(false);
        }
    }

    // Проверка, заполнен ли инпут
    const isInputFilled = () => {
        return depositAmount.trim() !== '';
    };

    // Обработчик нажатия Enter
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && isInputFilled() && isValid) {
            validateDepositAmount();
            // Снимаем фокус с инпута
            document.activeElement.blur();
        }
    };

    return (
        <div className='deposit'>
            <input
                type="text"
                placeholder="Enter deposit amount"
                value={depositAmount}
                onChange={(e) => {
                    setDepositAmount(e.target.value);
                    setIsValid(true);
                }}
                onKeyDown={handleKeyDown} // Добавляем обработчик Enter
                id="input_dep"
                className={`deposit__input ${isValid ? '' : 'deposit__input--error'}`}
            />
            <button
                className="deposit__btn"
                onClick={validateDepositAmount}
            >
                Submit
            </button>
        </div>
    )
}

export default Deposit;